import { z } from 'zod';
import { ALARM_LEVELS } from '@atnt/shared';

/**
 * URL state of the alarms page. Kept apart from the page modules so the route config (always in the main bundle)
 * imports only this, while the page stays in the route's lazy chunk.
 */

export const ALARM_TABS = ['events', 'settings'] as const;
export type AlarmTab = (typeof ALARM_TABS)[number];
export const ALARM_STATUS_FILTERS = ['open', 'closed', 'all'] as const;

/** `/t/:slug/alarms?tab=&status=&level=&unack=&q=&page=` */
export const alarmsSearchSchema = z.object({
  tab: z.enum(ALARM_TABS).optional().catch(undefined),
  status: z.enum(ALARM_STATUS_FILTERS).optional().catch(undefined),
  level: z.enum(ALARM_LEVELS).optional().catch(undefined),
  unack: z.boolean().optional().catch(undefined),
  q: z.string().max(200).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
});
export type AlarmsSearch = z.infer<typeof alarmsSearchSchema>;
